import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'light',
  // 拂晓蓝
  colorPrimary: '#31a17d',
  layout: 'mix',
  contentWidth: 'Fluid',
  fixedHeader: false,
  fixSiderbar: true,
  siderWidth: 210,
  colorWeak: false,
  // title: '油烟监智慧化平台',
  title: process.env.NODE_ENV === 'development' ? '火花智慧化平台' : '油烟智慧化平台',
  pwa: false,
  logo: process.env.NODE_ENV === 'development' ? 'https://sso.huohua.cn/assets/images/login/huohua.cn.avatar.png' : 'https://static.yyzhhpt.com/upload/image/20260922/26092210114U92.png',
  iconfontUrl: '',
  token: {
    // 参见ts声明，demo 见文档，通过token 修改样式
    //https://procomponents.ant.design/components/layout#%E9%80%9A%E8%BF%87-token-%E4%BF%AE%E6%94%B9%E6%A0%B7%E5%BC%8F
    sider: {
      colorTextMenu: 'rgba(0, 0, 0, 0.85)',
      colorTextMenuItemHover: '#31a17d',
      colorTextMenuSelected: '#31a17d',
    },
  },
};

export default Settings;
